"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_router_dom_1 = require("react-router-dom");
var react_query_1 = require("react-query");
var trans_1 = __importDefault(require("@/plugins/trans"));
var date_fns_1 = require("date-fns");
var LocalApplicationContext_1 = __importDefault(require("./context/LocalApplicationContext"));
var AppLayout_1 = require("../AppLayout");
var classes = {
    buttonGroup: {
        display: 'flex',
        flexDirection: 'row',
        gap: '16px',
        marginBottom: 2,
        paddingTop: 4,
        paddingLeft: { xs: 3, md: 0 },
    },
    button: {
        color: 'black',
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '18px',
        '&.active': {
            color: 'primary.main',
            backgroundColor: 'white',
            borderRadius: '50px',
            padding: { xs: 4, md: 2 },
            border: '1px solid',
            borderColor: 'primary.main',
        },
    },
};
var PreHired = function (_a) {
    var application = _a.application;
    var navigate = (0, react_router_dom_1.useNavigate)();
    return ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", onClick: function () { return navigate('./complete'); } }, { children: trans_1.default.get('buttons.frontend.application.confirm_hired') })));
};
var Status = function (_a) {
    var application = _a.application;
    if (!application.isAvailable && application.currentStatus.machine_name !== 'pre_hired') {
        return ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", color: "secondary", sx: { fontSize: 32, fontWeight: 'bold', wordBreak: 'break-word' } }, { children: trans_1.default.get('labels.frontend.vacancy.not_available_anymore') })));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5", color: "secondary", sx: { fontSize: 32, fontWeight: 'bold', wordBreak: 'break-word' } }, { children: application.appliedTimeAgo
                    ? trans_1.default.get('labels.frontend.applications.applied_date', {
                        date: (0, date_fns_1.format)(new Date(application.appliedTimeAgo), 'd-M-y'),
                    })
                    : trans_1.default.get('labels.frontend.applications.in_concept') })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "subtitle2", sx: { wordBreak: 'break-word' } }, { children: trans_1.default.get('labels.frontend.applications.status', {
                    status: trans_1.default.get("columns.application.status.frontend.".concat(application.currentStatus.machine_name)),
                }) }))] }));
};
function Application() {
    var applicationParam = (0, react_router_dom_1.useParams)().applicationId;
    var _a = (0, react_query_1.useQuery)(['application', applicationParam], function () {
        return axios_1.default.get("/data/applications/".concat(applicationParam, "/show")).then(function (result) { return result.data; });
    }), isLoading = _a.isLoading, application = _a.data;
    var handleSetApplication = (0, react_1.useContext)(LocalApplicationContext_1.default).handleSetApplication;
    (0, react_1.useEffect)(function () {
        if (!isLoading && application) {
            handleSetApplication(application);
        }
        return function () {
            handleSetApplication(undefined);
        };
    }, [application, isLoading, handleSetApplication]);
    if (isLoading || !application) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
            border: '1px solid',
            borderColor: 'primary.main',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            boxShadow: '0px 5px 35px 0px #0003411A',
            backgroundColor: 'white',
        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid',
                    borderColor: 'primary.main',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: AppLayout_1.appLayoutClasses.spacing }, { children: (0, jsx_runtime_1.jsx)(Status, { application: application }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: "flex", flexDirection: "column", justifyContent: "center", sx: AppLayout_1.appLayoutClasses.spacing }, { children: application.currentStatus.machine_name === 'pre_hired' && (0, jsx_runtime_1.jsx)(PreHired, { application: application }) }))] })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: __assign({ display: 'flex', flexDirection: 'column', whiteSpace: { xs: 'nowrap' } }, AppLayout_1.appLayoutClasses.spacing) }, { children: (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.buttonGroup }, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "chat" }, { children: trans_1.default.get('entities.company_conversation') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "about" }, { children: trans_1.default.get('entities.vacancy') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ sx: classes.button, component: react_router_dom_1.NavLink, to: "motivation" }, { children: trans_1.default.get('columns.application.motivation') }))] })) })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })));
}
exports.default = Application;
